import React from "react";
import SVGFoundation from "../../../svg-foundation/svg-foundation";
export default class CancelIcon extends SVGFoundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
            titleText: void 0,
        };
    }
    render() {
        return (React.createElement("svg", Object.assign({}, this.unhandledProps()),
            this.renderTitleText(this.props),
            React.createElement("path", { 
                /* tslint:disable-next-line */
                d: "M14.1016 1.60156L8.20312 7.5L14.1016 13.3984L13.3984 14.1016L7.5 8.20312L1.60156 14.1016L0.898438 13.3984L6.79688 7.5L0.898438 1.60156L1.60156 0.898438L7.5 6.79688L13.3984 0.898438L14.1016 1.60156Z" })));
    }
}
